/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89fe3422c549c74c55ed74db9586227a>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Assets".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/assets
 * Usage guidance:
 * Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const AssetsIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "AssetsIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.487 2.013a1.75 1.75 0 1 0-2.474 2.474 1.75 1.75 0 0 0 2.474-2.474M.952.952A3.25 3.25 0 0 1 6.412 2.5H9.5V4H6.413a3.24 3.24 0 0 1-.865 1.548c-.442.442-.98.73-1.548.865V9.5H2.5V6.413A3.25 3.25 0 0 1 .952.953M10.5 3.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m3 3.25v3H12v-3zM1 12.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m9.5 0a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m-1 .75h-3V12h3z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
AssetsIcon.displayName = 'AssetsIcon';
var _default = exports.default = AssetsIcon;